import type { ProjectType } from '@atlassian/jira-common-constants';
import {
	CORE_PROJECT,
	PRODUCT_DISCOVERY_PROJECT,
	SERVICE_DESK_PROJECT,
	SOFTWARE_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types.tsx';
import location from '@atlassian/jira-common-location';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type { JiraProjectType } from '@atlassian/jira-relay/src/__generated__/uiProjectVersionsQuery.graphql';

export const isVersionAdminContext = (): boolean => {
	// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
	const pathname = (location() && location().pathname) || '';
	const isVersionAdminContextSatisfied =
		pathname.endsWith && pathname.endsWith('/administer-versions');
	// Is it possible for any projects to satisfy this condition in jira-cloud? Can we remove this?
	if (isVersionAdminContextSatisfied) {
		log.safeInfoWithoutCustomerData(
			'@atlassian/jira-project-versions',
			'isVersionAdminContext is true',
		);
	}
	return isVersionAdminContextSatisfied;
};

export const getProjectType = (
	projectType: JiraProjectType | null | undefined,
): ProjectType | null => {
	switch (projectType) {
		case 'BUSINESS':
			return CORE_PROJECT;
		case 'SOFTWARE':
			return SOFTWARE_PROJECT;
		case 'SERVICE_DESK':
			return SERVICE_DESK_PROJECT;
		case 'PRODUCT_DISCOVERY':
			return PRODUCT_DISCOVERY_PROJECT;
		default:
			return null;
	}
};
